





















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import SkalaNyeri from "@/components/pemeriksaan/assesmen/SkalaNyeri.vue";
import Lokasi from "@/components/pemeriksaan/assesmen/Lokasi.vue";
import Intensitas from "@/components/pemeriksaan/assesmen/Intensitas.vue";
import Durasi from "@/components/pemeriksaan/assesmen/Durasi.vue";
import Frekuensi from "@/components/pemeriksaan/assesmen/Frekuensi.vue";
import Pencetus from "@/components/pemeriksaan/assesmen/Pencetus.vue";
import KualitasNyeri from "@/components/pemeriksaan/assesmen/KualitasNyeri.vue";
import PolaSerangan from "@/components/pemeriksaan/assesmen/PolaSerangan.vue";
import PenyebabNyeriHilang from "@/components/pemeriksaan/assesmen/PenyebabNyeriHilang.vue";
import JenisNyeri from "@/components/pemeriksaan/assesmen/JenisNyeri.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeAssesmenRalan } from "@/store/modules/asesmenralan";
// import CardRiwayatNyeri from "@/components/pemeriksaan/assesmen/CardRiwayatNyeri.vue";

@Component({
  components: {
    SkalaNyeri,
    Lokasi,
    Intensitas,
    Durasi,
    Frekuensi,
    Pencetus,
    KualitasNyeri,
    PolaSerangan,
    PenyebabNyeriHilang,
    JenisNyeri,
  },
})
export default class Nyeri extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop() showBtn!: boolean;
  @Prop() showRiwayat!: boolean;
  @Prop() statNyeri!: object;

  hideSkala = false;

  get nyeri() {
    return this.statNyeri;
  }

  setSkalaNyeri(val) {
    // console.log("setSkalaNyeri", val);

    if (val > 0) {
      this.hideSkala = false;
      this.nyeri["jenis"] = "1";
    } else {
      this.hideSkala = false;
    }
    this.nyeri["skala"] = val;
  }
  setLokasi(val) {
    this.nyeri["lokasi"] = val;
  }
  setIntensitas(val) {
    this.nyeri["intensitas"] = val;
  }
  setDurasi(val) {
    this.nyeri["durasi"] = val;
  }
  setFrekuensi(val) {
    this.nyeri["frekuensi"] = val;
  }
  setPencetus(val) {
    this.nyeri["pencetus"] = val;
  }
  setKualitasNyeri(val) {
    this.nyeri["kualitas"] = val;
  }
  setPolaSerangan(val) {
    this.nyeri["pola_serangan"] = val;
  }
  setPenyebabNyeriHilang(val) {
    this.nyeri["penyebab_hilang"] = val;
  }
  setJenisNyeri(val) {
    this.nyeri["jenis"] = val;
  }

  get stateAsesmenAwal() {
    return storeAssesmenRalan.asesmenAwal;
  }

  mounted() {}

  @Watch("nyeri")
  changeNyeri(val) {
    if (val["skala"] > 0) {
      this.hideSkala = false;
      // console.log(">0");
    } else {
      // console.log("=0");
      this.hideSkala = false;
    }
    console.log("setSkalaNyeri", val);

    this.$emit("nyeri", this.nyeri);
    // this.$emit("nyeri", this.nyeri);
  }
}
